<div class="dialog">
  <img class="big-icon" src="/assets/icons/special/picflow-user.svg" alt="" />

  <h1>Account Exists</h1>
  <p data-test-id="desc">It looks like you already have a Picflow account. Please login to continue.</p>

  <button
    appButton
    name="login"
    location="user-found-dialog"
    color="primary"
    height="4"
    size="3"
    weight="bold"
    spacing="full"
    (click)="close(true)"
    class="cta"
  >
    Login
  </button>
</div>
